import React, {useEffect, useState} from "react";
import {Title} from "../../../components/components";
import {useGetCmpAppsQuery,} from "../../../api/cmpApiSlice";
import {useHistory, useParams} from "react-router-dom";
import {useGetPublisherQuery} from "../../../api/publisherApiSlice";
import CmpApps from "../../../components/cmp/CmpApps";
import {CmpPreview} from "../../../components/cmp/CmpPreview";

import CmpConfiguration from "../../../components/cmp/CmpConfiguration";
import {useDeleteAppGroupMutation, useGetAppGroupQuery, useUpdateAppGroupMutation} from "../../../api/appGroupApiSlice";
import Icon from "../../../components/Icon";
import {Button} from "react-bootstrap";
import {AppGroupModal} from "../../../components/cmp/AppGroupModal";
import {useControlledTabs} from "../../../components/Tabs";
import {useTranslation} from "react-i18next";
import usePublisherCmpConfiguration from "../../api_hooks/usePublisherCmpConfiguration";

export default function CmpAppGroupConfiguration(props) {
  const { t } = useTranslation();
  const {appGroupId} = useParams();
  const history = useHistory();
  const params = {configurableType: 'app_group', configurableId: appGroupId}
  const [showAppGroupModal, setShowAppGroupModal] = useState(false)

  const {data: appGroup = {}, isAppGroupSuccess} = useGetAppGroupQuery({appGroupId})
  const {data: apps = {}, isSuccess: isAppsSuccess} = useGetCmpAppsQuery(params)
  const {cmpPreviewProps, cmpConfigurationProps} = usePublisherCmpConfiguration(params)
  const [updateAppGroup] = useUpdateAppGroupMutation()
  const [deleteAppGroup] = useDeleteAppGroupMutation()

  const [tabProps, setActiveTab] = useControlledTabs("cmp.popup", props)

  const onBack = () =>(history.push(`/cmp/configuration`))
  const onUpdate = (data) => {
    updateAppGroup({appGroupId, appGroup: data}).unwrap().then((data) => {
      setShowAppGroupModal(false)
      setActiveTab("cmp.apps")
    })
  }

  const onDelete = (data) => {
    deleteAppGroup({appGroupId}).unwrap().then(onBack)
  }

  return (
    <>
      <Title main={appGroup.name} sub="CMP Configuration" onBack={onBack}>
        <Button onClick={() => setShowAppGroupModal(true)}><Icon icon={"edit"}/>{t("cmp.appGroups.edit")}</Button>
      </Title>
      <CmpConfiguration {...cmpConfigurationProps} tabProps={tabProps}>
        <CmpApps
          icon={"app"}
          as={"cmp.apps"}
          apps={apps}
          setAppPreviewId={cmpPreviewProps.setAppPreviewId}/>
      </CmpConfiguration>
      <AppGroupModal show={showAppGroupModal}
                     setShow={setShowAppGroupModal}
                     appGroup={appGroup}
                     editable={true}
                     onUpdate={onUpdate}
                     onDelete={onDelete}
                     deleteAppGroup={deleteAppGroup}/>
      <CmpPreview {...cmpPreviewProps} />
    </>
  )
}
